/**
 * An object representing a custom topic model
 * @typedef {Object} CustomTopicModel
 */

import { Model } from '@/pigeonline/wrapper';

export default class CustomTopicModel extends Model {
  constructor(data = {}) {
    super(data);

    if (data && data._id) this.id = data._id.$oid;

    this.group_id = ''; // inherited from group
    this.keyword_objects = [];
    this.lang = 'en'; //inherited from group
    this.name = 'theme';
    this.source = {}; // inherited from group
    this.tags = []; //inherited from group
    this.include_ml_metadata = false;

    this.setProps(data);
  }
}
